import config from '@config/seo_meta.json'
import Image from "next/legacy/image"
interface Props {
  slice: any
}
const BannerV2 = ({ slice }: Props) => {
  const { primary } = slice
  const bannerImage = primary?.bannerImage
  const imageCredit = primary?.imageCredit
  const imageLayout = primary?.imageLayout

  return (
    <div className="bg-ui-light-grey w-full pb-10 lg:pb-20">
      {bannerImage && (
        <>
          <div
            className={`w-full ${
              imageLayout == '21:9' ? 'h-[608px]' : 'h-[810px]'
            } relative lg:block hidden`}
          >
            <Image
              src={bannerImage?.url || '/product-img-placeholder.svg'}
              alt={bannerImage?.alt || config.openGraph.images[0].alt}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div className="w-full h-[375px] relative lg:hidden block">
            <Image
              src={bannerImage?.url || '/product-img-placeholder.svg'}
              alt={bannerImage?.alt || config.openGraph.images[0].alt}
              layout="fill"
              objectFit="cover"
            />
          </div>
        </>
      )}
      {imageCredit && (
        <div className="wrapper flex justify-end body-2 pt-3">
          {imageCredit}
        </div>
      )}
    </div>
  )
}

export default BannerV2
